import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {Separator, Text} from 'trpc-react-native-ui';
import FormatService from '../../../../lib/format';
import I18n from '../../../../lib/i18n';
import theme from '../../../../config/themes/kaizen';
import WizzeeLog from '../../../../lib/wizzeeLog';
export default class SimPrice extends Component {
  render() {
    const {simPrice, eSimSelected, eSimPrice} = this.props;
    WizzeeLog.log('>>> SimPrice() - eSimPrice: ', JSON.stringify(eSimPrice));
    WizzeeLog.log('>>> SimPrice() - simPrice: ', JSON.stringify(simPrice));
    const styles = getStyles();
    if (simPrice === undefined && eSimPrice === undefined) {
      return null;
    }

    return (
      <>
        <View style={styles.simCardPriceContainer}>
          <Text style={styles.simPriceLabel}>
            {eSimSelected
              ? I18n.t('SignUp.ConfirmPlan.eSimCardLabel')
              : I18n.t('SignUp.ConfirmPlan.simCardLabel')}
          </Text>
          <Text style={styles.simPriceValue}>
            {eSimSelected
              ? FormatService.formatCentsToCurrency(
                  eSimPrice.price.taxIncludedAmount,
                  true,
                )
              : FormatService.formatCentsToCurrency(
                  simPrice?.taxIncludedAmount,
                  true,
                )}
          </Text>
        </View>
        {this.props.withSeparator && <Separator noMargin />}
      </>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    simCardPriceContainer: {
      flexDirection: 'row',
      width: '100%',
      height: 50,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    simPriceLabel: {
      fontWeight: '500',
      color: theme.defaultTextColor,
      fontSize: 16,
    },
    simPriceValue: {
      color: theme.confirmPlanPriceColor,
      fontSize: 16,
    },
  });
